import Vue from "vue";
import { mapGetters, mapState } from "vuex";

import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnDecimal, GridColumnType } from "@/components/child/grid/gridColumn";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component, Prop, Watch } from "@/decorators";
import CorManipulacao from "@/models/enum/corManipulacao";
import DestinosManipulacao from "@/models/enum/destinosManipulacao";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import SituacoesManipulacaoOrdem from "@/models/enum/situacoesManipulacaoOrdem";
import SubGrupoProduto from "@/models/enum/subGrupoProduto";
import TipoCalculoAssociacao from "@/models/enum/tipoCalculoAssociacao";
import TiposCalculoManipulacao from "@/models/enum/tiposCalculoManipulacao";
import TiposItemManipulacao from "@/models/enum/tiposItemManipulacao";
import TiposProduto from "@/models/enum/tiposProduto";
import UnidadesMedida from "@/models/enum/unidadesMedida";
import FormulaPadraoModel from "@/models/formulaPadraoModel";
import ManipulacaoOrdemItemModel from "@/models/manipulacaoOrdemItemModel";
import ManipulacaoOrdemModel from "@/models/manipulacaoOrdemModel";
import ProdutoModel from "@/models/produto/produtoModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import UsuarioModel from "@/models/usuarioModel";
import capsulaCoresService from "@/services/capsulaCoresService";
import capsulaService from "@/services/capsulaService";
import formulaPadraoDesmembradoService from "@/services/formulaPadraoDesmembradoService";
import formulaPadraoService from "@/services/formulaPadraoService";
import ManipulacaoOrdemItemService from "@/services/manipulacaoOrdemItemService";
import produtoESinonimosService from "@/services/produto/produtoESinonimosService";
import produtoService from "@/services/produto/produtoService";
import ProdutoLoteService from "@/services/produtoLoteService";
import unidadeMedidaService from "@/services/unidadeMedidaService";
import {
    ItemTableType,
    ManipulacaoContextNewActions,
    ManipulacaoContextNewMutations,
    ManipulacaoContextNewState,
} from "@/store/manipulacaoContextNew/types";
import { AppState, Getters } from "@/store/store";
import { getProdutoLoteCombo } from "@/utils/common/combo/combotext";
import Delay from "@/utils/common/delay";

import ProdutoVerComponent from "../crud/produto/verProduto";
import produtoVerComponent from "../crud/produto/verProduto.vue";

import { getItemManipulacaoByProduto } from "./manipulacaoUtils";

import "./item.scss";

@Component({
    components: {
        comboComponent,
        checkboxComponent,
        moedaComponent,
        decimalComponent,
        decimalComSinalCustomComponent,
        gridComponent,
        produtoVerComponent,
        searchComboComponent,
    },
    computed: {
        ...mapState<AppState>({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
        ...mapGetters(["GET_MANIPULACAO_CONTEXT_NEW", "GET_IS_FRACIONAMENTO", "GET_IS_ESTEREIS"] as Getters),
        isAssociado() {
            return this.model.produtoAssociadoPaiId != null;
        },
        isFlavorizante() {
            return this.model.produto?.subGrupo == SubGrupoProduto.Flavorizante;
        },
        isFormaFarmaceutica() {
            return this.model.formaFarmaceuticaId != null;
        },
        isDisabledEdicaoPreVenda() {
            return this.manipulacao.isPreVenda && !this.manipulacao.isPreVendaEditavel;
        },
        backGroundColor() {
            if (this.produtoId > 0 && this.model.produto) {
                switch (this.model.produto?.corManipulacao) {
                    case CorManipulacao.Vermelho:
                        return "background-red";
                    case CorManipulacao.Roxo:
                        return "background-purple";
                    case CorManipulacao.Verde:
                        return "background-green";
                    case CorManipulacao.Azul:
                        return "background-blue";
                    case CorManipulacao.Laranja:
                        return "background-orange";
                    case CorManipulacao.Amarelo:
                        return "background-yellow";
                }
            }
            return "";
        },
    } as any,
})
export default class ManipulacaoItemComponent extends Vue {
    // State computed props
    GET_MANIPULACAO_CONTEXT_NEW!: (uuid: string) => ManipulacaoContextNewState;
    isAssociado!: boolean;
    usuarioLogado!: UsuarioModel;
    isFlavorizante!: boolean;
    isFormaFarmaceutica!: boolean;
    GET_IS_FRACIONAMENTO: () => Promise<boolean>;
    GET_IS_ESTEREIS: () => Promise<boolean>;

    isFracionamento = false;
    isEstereis = false;

    private produtoLoteService = new ProdutoLoteService();
    private manipulacaoOrdemItemService = new ManipulacaoOrdemItemService();

    private produtoVerComponent: ProdutoVerComponent | null = null;

    model = new ManipulacaoOrdemItemModel();
    private produtoPaiPuro: ProdutoModel | null = null;

    private timer: number | null = null;

    public isFormulaPadrao = false;
    private formulaPadraoModel = new FormulaPadraoModel();
    private itensDesemembradosFormulaBase: Array<ManipulacaoOrdemItemModel> = [];

    private unidadeMedidaIdProduto = 0;
    private produtoId: number | null = null;
    private changeProdutoId = false;

    private produtosOptions: Array<any> = [];
    private lotesOptions: Array<any> = [];
    private formulaPadraoOptions: Array<any> = [];
    private tipoItemOptions: Array<any> = EnumExtensions.getNamesAndValuesOrderedByNames(TiposItemManipulacao);
    private tiposCalculoOptions: Array<any> = [];
    private unidadeMedidaOptions: Array<any> = [];
    private capsulasOptions: Array<any> = [];
    private coresCapsulasOptions: Array<any> = [];

    private loading = false;
    private loadingFormulaPadrao = false;
    private nivelItemDesmembrado = 0;

    private unsubscribe: (() => void) | null = null;

    private manipulacao = new ManipulacaoOrdemModel();
    private manipulacaoContext = new ManipulacaoContextNewState();

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("produtoDescricao", this.$t("__.ts.descr"), GridColumnType.Raw),
            new GridColumnDecimal("formulaPadraoItemQuantidadeDose", this.$t("__.ts.qtdeFormPadrao"), 4),
            new GridColumnDecimal("quantidadePesagem", this.$t("__.ts.qtdTotalPesado"), 4),
        ];
    }

    @Prop({ type: Number, required: true }) index!: number;
    @Prop({ type: Object, default: () => null }) itemModel!: ManipulacaoOrdemItemModel;
    @Prop({ type: Number, default: 0 }) setorId!: number;

    //0 = ativos, 1 = embalagens,  2 = capsulas
    @Prop(Number) itemType!: number;

    @Prop({ type: String, required: true }) uuid!: string;

    @Watch("model", { deep: true })
    private onChangeModel() {
        if (
            !this.manipulacaoContext.isConsolidando &&
            (this.model.produtoId || this.model.tipoCalculo) &&
            !this.loadingFormulaPadrao
        ) {
            this.dispatch(ManipulacaoContextNewActions.ADD_ITEM_MANIPULACAO_NEW, {
                item: this.model,
                type: this.itemType,
                index: this.index,
            });
        }
    }

    public clear() {
        this.model = new ManipulacaoOrdemItemModel();
        this.produtoId = null;
        this.model.produtoId = 0;
        this.model.tipoCalculo = undefined;
        this.model.quantidadeDose = 0;
        this.model.unidadeMedidaManipulacaoId = 0;
        this.model.quantidade = 0;
        this.model.quantidadePesagem = 0;
        this.model.valor = 0;
        this.model.valorTotal = 0;
        this.model.fatorUTR = undefined;
    }

    private async loadFormulaPadrao(refresh = false) {
        this.formulaPadraoOptions = await formulaPadraoDesmembradoService.comboCached(
            this.usuarioLogado.franquiaId ?? 0,
            refresh,
        );
    }

    @Watch("setorId")
    private onSetorIdChange() {
        this.loadProdutoOptions();
    }

    @Watch("manipulacaoContext.estoqueFranquiaId")
    private onEstoqueFranquiaIdChange() {
        this.loadProdutoOptions();
    }

    private async loadProdutoOptions() {
        const franquiaId = this.manipulacaoContext.isFranquiaFilial
            ? this.manipulacaoContext.estoqueFranquiaId
            : this.usuarioLogado.franquiaId;

        let produtos: any[] = (await produtoESinonimosService.comboCached(franquiaId ?? 0)) ?? [];
        let filteredProdutos: any[] = [];

        if (this.setorId) {
            produtos = produtos.filter(p => p["setorBloqueadoId"] != this.setorId);
        }

        // se for de materia prima, sub grupo for ativo e não for homeopatia
        if (
            this.manipulacao.formaFarmaceuticaId > 0 &&
            this.itemType == ItemTableType.ATIVO &&
            !this.manipulacao.homeopatia
        ) {
            produtos = produtos.filter(
                p =>
                    (p.tipoProduto == TiposProduto.MateriaPrima ||
                        p.tipoProduto == TiposProduto.Homeopatia ||
                        p.tipoProduto == TiposProduto.SemiAcabado) &&
                    (p.formasFarmaceuticas == null ||
                        p.formasFarmaceuticas.length == 0 ||
                        p.formasFarmaceuticas.some((forma: any) => forma.id == this.manipulacao.formaFarmaceuticaId) ||
                        !p.formasFarmaceuticas.some((forma: any) => forma.id == this.manipulacao.formaFarmaceuticaId)),
            );
        }

        if (this.isFlavorizante) {
            filteredProdutos = produtos.filter(p => p["subGrupo"] == SubGrupoProduto.Flavorizante);
        } else if (this.model.produto?.subGrupo != null && this.itemType != ItemTableType.ATIVO) {
            filteredProdutos = produtos.filter(p => p["subGrupo"] == this.model.produto?.subGrupo);

            if (!filteredProdutos.some(p => p["value"] == this.produtoId)) {
                filteredProdutos = produtos;
            }
        } else {
            filteredProdutos = produtos;
        }

        if (this.manipulacao.situacao != SituacoesManipulacaoOrdem.Concluido) {
            filteredProdutos = filteredProdutos.filter(p => p["ativo"]);
        }

        this.produtosOptions = filteredProdutos;
    }

    public async validateAll() {
        try {
            const isValid = await this.$validator.validateAll();
            if (!isValid) {
                if (this.manipulacao.homeopatia) {
                    await this.$showError(
                        this.$t("__.ts.erro"),
                        `${this.$t("__.ts.obrigatorioinformarLoteParaProduto")} ${this.model.produto?.descricao ?? ""}`,
                    );
                }
                this.$focusErrorField();
            }
            return isValid;
        } catch {}

        return false;
    }

    public forceUpdate() {
        this.$forceUpdate();

        this.loadProdutoId();
    }

    private async calculaQuantidadeAssociacaoVolumeTotal(item: ManipulacaoOrdemItemModel) {
        let quantidade =
            (item.quantidadeDose / 100) * (this.manipulacao.volumeTotal / (this.manipulacao.numeroFormulas ?? 1));

        if (item.fatorCorrecao) {
            quantidade *= item.fatorCorrecao;
        }

        if (item.fatorEquivalencia) {
            quantidade *= item.fatorEquivalencia;
        }

        const indiceConversao = await this.manipulacaoContext.indicesConversoesUnidadeMedidasService.getIndiceConversao(
            this.manipulacao.unidadeMedidaId,
            item.unidadeMedidaId,
            item.densidade,
            item.produtoId,
            item.produtoLoteId,
        );

        item.quantidade = quantidade;
        item.quantidadePesagem = quantidade * indiceConversao;
        return item;
    }

    @Watch("manipulacao.usaMarkupEquinos")
    private async onChangeUsaMarkupEquinos() {
        this.loadManipulacaoContext();
        this.loadProduto();

        if (this.model.produto?.id) {
            if (this.manipulacao.usaMarkupEquinos) {
                this.loadValoresProdutoByLote(true, this.manipulacao);
            } else {
                this.model.valor = this.model.produto.valorVenda ?? 0;
            }
        }

        this.dispatch(ManipulacaoContextNewActions.UPDATE_MANIPULACAO_NEW, { ...this.manipulacao });
    }

    private async carregarProduto() {
        this.loadManipulacaoContext();

        try {
            if (!this.model.produto?.id || this.model.produto.id != this.model.produtoId) {
                this.model.produto = await produtoService
                    .getByIdFromManipulacao(this.model.produtoId)
                    .withLoading()
                    .resolveWithJSON<ProdutoModel>();
            }

            const { item, produto } = getItemManipulacaoByProduto(
                this.model.produto,
                this.model,
                this.manipulacaoContext,
                this.itemType,
            );

            if (!this.manipulacao.usaMarkupEquinos) {
                item.valor = 0;
                if (produto.valorVenda) {
                    item.valor = produto.valorVenda;
                }
            }

            const newItem = { ...item } as ManipulacaoOrdemItemModel;
            this.model.updateFrom(newItem);
            this.model.produto = produto;

            if (this.model.produto?.subGrupo != null) {
                await this.loadProdutoOptions();
            }

            this.loadProdutoPaiPuro();

            const produtoAtual = this.model.produto;
            this.$emit("onChangeMovimentaEstoque", !produtoAtual?.ignoraControleEstoque);

            if (this.manipulacaoContext.isCapsula && (produtoAtual?.volumeCapsula ?? 0) > 0) {
                this.$emit("onAlterarVolumeCapsula", produtoAtual.volumeCapsula, produtoAtual.descricao);
            }

            if (this.isFormulaPadrao && !this.formulaPadraoModel.unidadeMedidaId) {
                this.formulaPadraoModel.unidadeMedidaId = this.model.unidadeMedidaId;
            }
        } catch {}
    }

    @Watch("itemModel", { deep: true })
    private onChangeItens() {
        this.model.updateFrom(this.itemModel);
        this.loadManipulacaoContext();

        if (this.manipulacao.formaFarmaceutica.desconsiderarDensidade) {
            this.model.densidade = 1;
        }

        this.loadProdutoId();
        this.loadProduto();

        this.isFormulaPadrao = false;
        if (this.model.tipoItem == TiposItemManipulacao.FormulaPadrao) {
            this.isFormulaPadrao = true;
        }

        if (!this.isFormulaPadrao) {
            this.itensDesemembradosFormulaBase = [];
        } else {
            const produtosDesmembrados = this.manipulacao.itens.filter(
                p => p.formulaPadraoId == this.model.formulaPadraoId && p.produtoPai,
            );
            this.itensDesemembradosFormulaBase = [];
            produtosDesmembrados.forEach(p => {
                this.itensDesemembradosFormulaBase.push(...this.getDesmembradosFromPaiId(p));
            });
        }
    }

    //@ts-ignore
    @Watch("model.capsulaId")
    private async onChangeCapsulaId(newValue: number, oldValue: number) {
        if (newValue && oldValue && newValue != oldValue) {
            this.manipulacao.consolidado = false;
            this.$emit("onConsolidado", false);
            this.dispatch(ManipulacaoContextNewActions.UPDATE_MANIPULACAO_NEW, { ...this.manipulacao });
        }

        this.loadProdutoCoresCapsulas();
    }

    //@ts-ignore
    @Watch("manipulacaoContext.manipulacao.formaFarmaceutica.tipoCapsula")
    private async onChangeTipoCapsula() {
        if (this.manipulacaoContext.manipulacao?.formaFarmaceutica?.tipoCapsula != null) {
            this.loadProdutoCoresCapsulas();
        }
    }

    private async onChangeProdutoId(newValue: number, oldValue: number) {
        if (!newValue || newValue == oldValue) {
            return;
        }
        this.produtoId = newValue;
        const franquiaId = this.manipulacaoContext.isFranquiaFilial
            ? this.manipulacaoContext.estoqueFranquiaId
            : this.usuarioLogado.franquiaId;
        const produtos: any[] = (await produtoESinonimosService.comboCached(franquiaId ?? 0)) ?? [];
        const produto = produtos.find(p => p["value"] == newValue);

        this.changeProdutoId = true;
        if (produto && produto["sinonimoId"]) {
            this.model.produtoId = produto["produtoId"];
            this.model.sinonimoId = produto["sinonimoId"];
            this.model.produtoDescricao = produto["text"];
        } else {
            this.model.produtoId = newValue;
            this.model.sinonimoId = 0;
        }

        await this.carregarProduto();

        this.loadManipulacaoContext();

        if (this.itemType == ItemTableType.CAPSULA) {
            this.$emit("onCorCapsulaChange", this.model);
        }
    }

    private loadProdutoId() {
        if (
            !this.changeProdutoId ||
            this.itemType == ItemTableType.EMBALAGEM ||
            this.itemType == ItemTableType.CAPSULA
        ) {
            if (this.model.sinonimoId && this.model.produtoId) {
                this.produtoId = this.model.sinonimoId * this.model.produtoId;
            } else {
                this.produtoId = this.model.produtoId;
            }
        }
        this.changeProdutoId = false;
    }

    private async onFormulaPadraoIdChanged(newValue: number) {
        if (!newValue || newValue == 0) {
            return;
        }
        // The combo emits @select before v-model updates model.formulaPadraoId,
        // so we must set it explicitly here to ensure carregarFormulaPadrao reads the correct ID.
        this.model.formulaPadraoId = newValue;
        await this.carregarFormulaPadrao().withLoading();

        await this.dispatch(ManipulacaoContextNewActions.CALCULAR_QSP_NEW, {
            loadDadosLote: false,
            ignoreDebounce: false,
        });

        await this.loadModelByFormulaPadrao();
    }

    private async loadModelByFormulaPadrao() {
        if (
            !this.model.formulaPadraoId ||
            this.loadingFormulaPadrao ||
            this.manipulacao.destino == DestinosManipulacao.Estoque
        ) {
            return;
        }

        this.loadingFormulaPadrao = true;

        const alterouQuantidade =
            this.manipulacaoContext.desmembrados
                .filter(p => p.formulaPadraoId == this.model.formulaPadraoId)
                .reduce((acc, p) => acc + p.quantidadePesagem, 0) != this.model.quantidadePesagem;

        // Se item já está salvo e os ativos desmembrados forem os mesmos não deve fazer nada
        if (
            (!alterouQuantidade && this.model.id) ||
            this.manipulacaoContext.desmembrados.some(p => p.quantidadeAlteradaManualmente)
        ) {
            this.loadingFormulaPadrao = false;
            return;
        }

        this.loadManipulacaoContext();

        this.manipulacao = await this.manipulacaoContext.manipulacaoOrdemService
            .loadDesmembradosByManipulacaoOrdemItem(this.model, this.manipulacao)
            .resolveWithJSON<ManipulacaoOrdemModel>();

        const produtosDesmembrados = this.manipulacao.itens.filter(
            p => p.formulaPadraoId == this.model.formulaPadraoId && p.produtoPai,
        );
        this.itensDesemembradosFormulaBase = [];
        produtosDesmembrados.forEach(p => {
            this.itensDesemembradosFormulaBase.push(...this.getDesmembradosFromPaiId(p));
        });

        for (const item of this.manipulacao.itens) {
            item.produtoDescricao = `${this.getNivelDesmembrado(item.produtoPai)}${item.produtoDescricao}`;
        }

        this.dispatch(ManipulacaoContextNewActions.UPDATE_MANIPULACAO_FROM_DESMEMBRADOS_NEW, { ...this.manipulacao });

        this.loadingFormulaPadrao = false;
    }

    public updateDesmembrado(produtosDesmembrados: ManipulacaoOrdemItemModel[]) {
        produtosDesmembrados.forEach(p => {
            if (!this.itensDesemembradosFormulaBase.some(item => item.produtoId == p.produtoId)) {
                this.itensDesemembradosFormulaBase.push(...this.getDesmembradosFromPaiId(p));
            }
        });
    }

    private getDesmembradosFromPaiId(manipulacaoItem: ManipulacaoOrdemItemModel, recursive = false) {
        let itens = this.manipulacao.itens.filter(p => p.produtoPai == manipulacaoItem.produtoId);
        itens.forEach(p => {
            if (!p.movimentaEstoque) {
                itens.push(...this.getDesmembradosFromPaiId(p, true));
            }
        });
        if (!recursive) {
            const itemPai = this.manipulacao.itens.find(p => p.produtoId == manipulacaoItem.produtoId);
            itens = itemPai ? [itemPai, ...itens] : itens;
        }
        return itens;
    }

    private getNivelDesmembrado(paiId?: number) {
        this.nivelItemDesmembrado = 0;
        this.hasItemFormulaPai(paiId);

        let text = "";
        for (let index = 0; index < this.nivelItemDesmembrado; index++) {
            text += "           ";
        }
        return text;
    }

    private hasItemFormulaPai(paiId?: number) {
        if (!paiId) {
            return;
        }

        const pai = this.itensDesemembradosFormulaBase.find(p => p.produtoId == paiId);
        if (pai) {
            this.nivelItemDesmembrado++;
            this.hasItemFormulaPai(pai.produtoPai);
        }
    }

    private async carregarFormulaPadrao() {
        this.loadManipulacaoContext();

        try {
            let data = new FormulaPadraoModel();
            if (this.manipulacaoContext.isFranquiaFilial && this.manipulacao.estoqueId) {
                data = await formulaPadraoService
                    .getFormulaByEstoque(this.model.formulaPadraoId ?? 0, this.manipulacao.estoqueId ?? 0)
                    .withLoading()
                    .resolveWithJSON<FormulaPadraoModel>();
            } else {
                data = await formulaPadraoService.get(this.model.formulaPadraoId ?? 0);
            }

            this.formulaPadraoModel.updateFrom(data);

            this.model.produto = data.produto;
            this.model.produtoId = data.produtoId ?? 0;
            this.model.produtoDescricao = data.produtoDescricao;

            this.model.valor = 0;
            if (data.produto.valorVenda) {
                this.model.valor = data.produto.valorVenda;
            }

            this.model.fatorCorrecao = undefined;
            if (data.produto.fatorCorrecao) {
                this.model.fatorCorrecao = data.produto.fatorCorrecao;
            }

            this.model.densidade = 1;
            if (data.produto.densidade) {
                this.model.densidade = data.produto.densidade;
            }

            if (data.produto.fatorUTR) {
                this.model.fatorUTR = data.produto.fatorUTR;
            }
            if (data.produto.fatorUFC) {
                this.model.fatorUFC = data.produto.fatorUFC;
            }

            if (data.produto.tipoCalculo) {
                // Se item não é QSP, mas está configurado como QSP e já tem QSP na manipulação deve manter o tipo de cálculo
                const manterTipoCalculo =
                    this.model.tipoCalculo &&
                    this.model.tipoCalculo != TiposCalculoManipulacao.Qsp &&
                    data.produto.tipoCalculo == TiposCalculoManipulacao.Qsp &&
                    this.manipulacao.itens.some(p => p.tipoCalculo == TiposCalculoManipulacao.Qsp);

                if (!manterTipoCalculo) {
                    this.model.tipoCalculo = data.produto.tipoCalculo;
                }
            }

            this.model.unidadeMedidaId = data.produto.unidadeMedidaEstoqueId ?? 0;
            this.model.unidadeMedidaManipulacaoId = data.produto.unidadeMedidaManipulacaoId ?? 0;
        } catch {}
    }

    //@ts-ignore
    @Watch("manipulacao.volumeTotal")
    private async onVolumeChanged() {
        this.calcularQuantidadeTotal();

        if (this.model.tipoCalculoAssociacao == TipoCalculoAssociacao.VolumeTotal) {
            this.model = await this.calculaQuantidadeAssociacaoVolumeTotal(this.model);

            await this.dispatch(ManipulacaoContextNewActions.ADD_ITEM_MANIPULACAO_NEW, {
                item: this.model,
                type: this.itemType,
                index: this.index,
            });
        }
    }

    //@ts-ignore
    @Watch("manipulacao.quantidade")
    private async onQuantidadeDosesChanged() {
        this.loadManipulacaoContext();
        if (this.manipulacao.volumeTotal > 0) return;

        if (this.model.tipoCalculo == TiposCalculoManipulacao.Dose) {
            await this.calculaDoseReplicaParaAtivos();
        } else {
            this.calcularQuantidadeTotal();
        }
    }

    //@ts-ignore
    @Watch("model.fatorEquivalencia")
    private onFatorEquivalenciaChanged() {
        this.calcularQuantidadeTotal();
    }

    //@ts-ignore
    @Watch("model.fatorCorrecao")
    private onFatorCorrecaoChanged() {
        this.calcularQuantidadeTotal();
    }

    //@ts-ignore
    @Watch("model.quantidadeDose")
    private async onQuantidadeDoseChanged() {
        this.loadManipulacaoContext();

        if (!this.manipulacaoContext.uploadingEditingModel) {
            await this.verificaDiluido();
        }

        if (this.model.tipoCalculo == TiposCalculoManipulacao.Dose) {
            await this.calculaDoseReplicaParaAtivos();
        } else {
            this.calcularQuantidadeTotal();
        }

        if (this.itemType == ItemTableType.CAPSULA && this.model.quantidadeDose > 0) {
            const quantidadeManipulacao = this.manipulacao.quantidade ?? 0;
            if (quantidadeManipulacao > 0 && this.model.quantidadeDose % quantidadeManipulacao != 0) {
                this.$showWarning(
                    this.$t("__.ts.atencao"),
                    `Quantidade precisa ser multiplo de ${quantidadeManipulacao} para que não ocorra problema nos volumes dos ativos!`,
                );
            }

            if (quantidadeManipulacao > 0) {
                this.manipulacao.fatorMultQuantidade = Math.round(this.model.quantidadeDose / quantidadeManipulacao);
                this.dispatch(ManipulacaoContextNewActions.UPDATE_MANIPULACAO_NEW, { ...this.manipulacao });
            }
        }
    }

    private async verificaDiluido() {
        const doseMaximaDiluido = this.model.doseMaximaDiluido ?? 0;
        const produtoDiluidoId = this.model.produtoDiluidoId ?? 0;

        //busca do puro para o diluido
        if (this.model.quantidadeDose > 0 && doseMaximaDiluido > 0 && produtoDiluidoId > 0) {
            if (this.produtosOptions.filter(p => p["value"] == produtoDiluidoId).length == 0) return;

            if (this.unidadeMedidaIdProduto == this.model.unidadeMedidaManipulacaoId) {
                if (this.model.quantidadeDose <= doseMaximaDiluido) {
                    const trocarProd = await this.perguntaProdutoDiluido();
                    if (trocarProd) {
                        this.produtoId = produtoDiluidoId;
                    }
                }
            } else {
                //busca conversao antes
                const idxConversao =
                    await this.manipulacaoContext.indicesConversoesUnidadeMedidasService.getIndiceConversao(
                        this.model.unidadeMedidaManipulacaoId,
                        this.unidadeMedidaIdProduto,
                    );

                const quantidadeComparar = this.model.quantidadeDose * idxConversao;
                if (quantidadeComparar <= doseMaximaDiluido) {
                    const trocarProd = await this.perguntaProdutoDiluido();
                    if (trocarProd) {
                        this.produtoId = produtoDiluidoId;
                    }
                }
            }
        }
        //busca do diluido para o puro
        else if (
            this.model.quantidadeDose > 0 &&
            this.produtoPaiPuro != null &&
            this.produtoPaiPuro.doseMaximaDiluido
        ) {
            if (this.produtoPaiPuro.unidadeMedidaManipulacaoId == this.model.unidadeMedidaManipulacaoId) {
                if (this.model.quantidadeDose > this.produtoPaiPuro.doseMaximaDiluido) {
                    const trocarProd = await this.perguntaProdutoDiluido(true);
                    if (trocarProd) {
                        this.produtoId = this.produtoPaiPuro.id ?? null;
                    }
                }
            } else {
                //busca conversao antes
                const idxConversao =
                    await this.manipulacaoContext.indicesConversoesUnidadeMedidasService.getIndiceConversao(
                        this.model.unidadeMedidaManipulacaoId,
                        this.produtoPaiPuro.unidadeMedidaManipulacaoId ?? 0,
                    );

                const quantidadeComparar = this.model.quantidadeDose * idxConversao;
                if (quantidadeComparar > this.produtoPaiPuro.doseMaximaDiluido) {
                    const trocarProd = await this.perguntaProdutoDiluido(true);
                    if (trocarProd) {
                        this.produtoId = this.produtoPaiPuro.id ?? null;
                    }
                }
            }
        }
    }

    private async perguntaProdutoDiluido(diluido = false) {
        const prodPuroDiluido = diluido ? this.$t("__.ts.puro") : this.$t("__.ts.diluido");

        const question = `${this.$t("__.ts.sisteIdentifProd")}${prodPuroDiluido}${this.$t(
            "__.ts.paraEssaQtdDose",
        )}${prodPuroDiluido}?`;

        return await this.$showQuestion(`${this.$t("__.ts.prod")} ${prodPuroDiluido}!`, question);
    }

    //@ts-ignore
    @Watch("model.valor")
    private onValorChanged() {
        this.calcularQuantidadeTotal();
    }

    //@ts-ignore
    @Watch("model.quantidade")
    private async onQuantidadeChanged(newValue: number, oldValue: number) {
        if (
            newValue &&
            oldValue &&
            newValue != oldValue &&
            this.model.tipoItem != TiposItemManipulacao.Capsula &&
            this.model.tipoItem != TiposItemManipulacao.KitEmbalagem
        ) {
            this.manipulacao.consolidado = false;
            this.dispatch(ManipulacaoContextNewActions.UPDATE_MANIPULACAO_NEW, { ...this.manipulacao });
        }

        if (this.isFormulaPadrao && this.model.tipoCalculo != TiposCalculoManipulacao.Qsp) {
            await this.loadModelByFormulaPadrao();
        } else if (this.model.tipoCalculo != TiposCalculoManipulacao.Qsp) {
            this.calcularQuantidadeTotal();
        }
    }

    //@ts-ignore
    @Watch("model.volumeDose")
    private async onVolumeDoseChanged() {
        this.calcularQuantidadeTotal();
    }

    private async onChangeVolumeDose(newValue: number) {
        this.$notifyWarn(this.$t("__.ts.ocorreuTrocaManual"), this.$t("__.ts.trocaDose"));

        await this.dispatch(ManipulacaoContextNewActions.REPLICA_DOSE_ATIVOS_NEW, {
            dose: newValue,
            isTrocaManual: true,
        });

        this.calcularQuantidadeTotal();
    }

    //@ts-ignore
    @Watch("model.unidadeMedidaManipulacaoId")
    private async onUnidadeMedidaManipulacaoChanged(newValue: number, oldValue: number) {
        const unMedManipulacao = this.unidadeMedidaOptions.filter(
            p => p["value"] == this.model.unidadeMedidaManipulacaoId,
        );

        if (unMedManipulacao.length > 0) {
            const unidadeUI = unMedManipulacao[0]["type"] == UnidadesMedida.UI;
            if (unidadeUI && (this.model.fatorUI == null || this.model.fatorUI == 0)) {
                await this.$showError(this.$t("__.ts.fatorUI"), this.$t("__.ts.naoHaFtrUI"));

                this.model.unidadeMedidaManipulacaoId = oldValue;
            }
        }

        this.calcularQuantidadeTotal();

        if (this.model.tipoCalculo == TiposCalculoManipulacao.Dose) {
            await this.calculaDoseReplicaParaAtivos();
        }
    }

    //@ts-ignore
    @Watch("model.tipoCalculo")
    private async onTipoCalculoChanged(newValue: number, oldValue: number) {
        switch (newValue) {
            case TiposCalculoManipulacao.Qsp:
                this.model.quantidadeDose = 1;
                this.model.unidadeMedidaManipulacaoId = this.model.unidadeMedidaId;
                break;
            case TiposCalculoManipulacao.Dose:
                if (!this.loading) {
                    await this.onChangeTiposCalculoManipulacaoDose();
                }
                break;
            case TiposCalculoManipulacao.UTRPercentual:
                this.setUnidadeMedidaUTR(UnidadesMedida.UTR);
                break;
            case TiposCalculoManipulacao.UIPercentual:
                this.setUnidadeMedidaUI(UnidadesMedida.UI);
                break;
            case TiposCalculoManipulacao.DH:
            case TiposCalculoManipulacao.CH:
                await this.onChangeTiposCalculoDinamizado();
                break;
            default:
        }

        if (newValue != TiposCalculoManipulacao.Dose && oldValue == TiposCalculoManipulacao.Dose) {
            this.model.volumeDose = undefined;
        }

        this.calcularQuantidadeTotal();

        if (newValue == TiposCalculoManipulacao.Dose || oldValue == TiposCalculoManipulacao.Dose) {
            this.$emit("onRefazerHeader");
        }
    }

    //@ts-ignore
    @Watch("manipulacao.unidadeMedidaId")
    private onUnidadeMedidaTotalChanged() {
        this.model.unidadeMedidaDoseId = this.manipulacao.unidadeMedidaId;
    }

    //@ts-ignore
    @Watch("manipulacao.formaFarmaceutica.desconsiderarDensidade")
    private onChangeDesconsiderarDensidade() {
        if (this.manipulacao.formaFarmaceutica.desconsiderarDensidade) {
            this.model.densidade = 1;
        } else {
            this.model.densidade = this.model.produto?.densidade ?? 0;
        }
    }

    //@ts-ignore
    @Watch("model.fatorUI")
    private onFatorUIChanged() {
        this.calcularQuantidadeTotal();
    }

    private async setUnidadeMedidaUTR(tipoUnidadeMedida: UnidadesMedida) {
        if (!this.model.fatorUTR) {
            return this.$showError(this.$t("__.ts.atencao"), "Este item não tem o 'Fator UTR' informado!");
        }

        const unidade = this.unidadeMedidaOptions.filter(p => p["type"] == tipoUnidadeMedida);

        if (unidade.length > 0) {
            this.model.unidadeMedidaManipulacaoId = unidade[0]["value"];
        } else {
            return this.$showError(this.$t("__.ts.atencao"), "Unidade de medida 'UTR' não encontrada!");
        }
    }

    private async setUnidadeMedidaUI(tipoUnidadeMedida: UnidadesMedida) {
        if (!this.model.fatorUI) {
            return this.$showError(this.$t("__.ts.atencao"), "Este item não tem o 'Fator UI' informado!");
        }

        this.unidadeMedidaOptions = await unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId ?? 0);
        const unidade = this.unidadeMedidaOptions.filter(p => p["type"] == tipoUnidadeMedida);

        if (unidade.length > 0) {
            this.model.unidadeMedidaManipulacaoId = unidade[0]["value"];
        } else {
            return this.$showError(this.$t("__.ts.atencao"), "Unidade de medida 'UI' não encontrada!");
        }
    }

    private calcularQuantidadeTotal() {
        this.loadManipulacaoContext();

        // Se está na replicação de venda deve forçar os calculos
        if (
            !this.$route.params.vendaReplicada &&
            (this.manipulacaoContext.uploadingEditingModel || this.manipulacaoContext.isDesabilitado)
        ) {
            return;
        }

        if (this.manipulacaoContext.isConsolidando || this.manipulacaoContext.uplodingPrevenda) {
            return;
        }

        if (this.timer != null) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => this.calcularQuantidadeTotalInterno(), this.loading ? 400 : 100);
    }

    private async calcularQuantidadeTotalInterno() {
        await this.dispatch(ManipulacaoContextNewActions.CALCULAR_QUANTIDADES_ITEM_NEW, {
            type: this.itemType,
            index: this.index,
            item: this.model,
        });

        if (
            this.manipulacao.formaFarmaceuticaId > 0 &&
            ((this.manipulacaoContext.ativos.length == 1 && this.manipulacaoContext.ativos[0].produtoId > 0) ||
                (this.model.tipoCalculo != null && this.model.tipoCalculo != TiposCalculoManipulacao.Qsp))
        ) {
            await this.dispatch(ManipulacaoContextNewActions.CALCULAR_QSP_NEW, {
                loadDadosLote: false,
                ignoreDebounce: false,
            });
        }

        if (this.isFormulaPadrao && this.model.tipoCalculo != TiposCalculoManipulacao.Qsp) {
            await this.loadModelByFormulaPadrao();
        }
    }

    public async calculaDoseReplicaParaAtivos() {
        await this.dispatch(ManipulacaoContextNewActions.ADD_ITEM_MANIPULACAO_NEW, {
            item: this.model,
            type: this.itemType,
            index: this.index,
        });

        if (!this.model.quantidadeDose || this.model.produtoAssociadoPaiId) {
            return;
        }

        await this.dispatch(ManipulacaoContextNewActions.CALCULA_DOSE_NEW, null);

        this.calcularQuantidadeTotal();
    }

    private async onChangeTiposCalculoManipulacaoDose() {
        this.loadManipulacaoContext();

        const dose = this.manipulacaoContext.ativos.find(p => p.tipoCalculo == TiposCalculoManipulacao.Dose);
        const volumeDose = dose?.volumeDose ?? 0;
        if (dose && volumeDose > 0) {
            await this.dispatch(ManipulacaoContextNewActions.REPLICA_DOSE_ATIVOS_NEW, {
                dose: volumeDose,
                isTrocaManual: false,
            });
        }

        await this.calculaDoseReplicaParaAtivos();
    }

    private async onChangeTiposCalculoDinamizado() {
        if (!this.produtoId) {
            return;
        }

        const data = await this.produtoLoteService
            .getListDinamizado(this.produtoId)
            .withLoading()
            .resolveWithJSON<ProdutoLoteModel[]>();

        this.lotesOptions = data.map(item => getProdutoLoteCombo(item, this.isFracionamento || this.isEstereis));

        const unidadeGt = this.unidadeMedidaOptions.find(p => p["text"] === "gt");
        if (unidadeGt) {
            this.model.unidadeMedidaManipulacaoId = unidadeGt["value"];
        }
        this.model.quantidadeDose = 4;
    }

    get showDose() {
        return this.model.tipoCalculo == TiposCalculoManipulacao.Dose;
    }

    private getTooltipValorFinal() {
        const valorStr = this.model.valor.toFixed(4).toString().replace(".", ",");
        return this.$t("__.ts.vlrUnit") + " R$" + valorStr;
    }

    private getTipoCalculoName(tipo: TiposCalculoManipulacao) {
        if (tipo != null && tipo != 0) {
            const tipoCalculo = this.tiposCalculoOptions.find(p => p["value"] == tipo);
            if (tipoCalculo) {
                return `${this.$t("__.ts.quantidade")} ${tipoCalculo["text"]}`;
            }
        }
        return "";
    }

    private getTootipQtdTotal(tipo: TiposCalculoManipulacao) {
        if (this.model.quantidadeAlteradaManualmente) {
            return "Quantidade alterada manualmente pelo usuário. Nesse caso o sistema não recalcula mais a quantidade e deve ser alterada pelo tela de Lotes/Estoque.";
        }

        let qtdStr = "";
        switch (tipo) {
            case TiposCalculoManipulacao.Unitario:
                qtdStr = this.$t("__.ts.qtdCapsMultQtdForma") as string;
                break;
            case TiposCalculoManipulacao.Percentual:
                qtdStr = this.$t("__.ts.qtdPercentVolForma") as string;
                break;
            case TiposCalculoManipulacao.Qsp:
                qtdStr = this.$t("__.ts.qtdSuficComplForma") as string;
                break;
            case TiposCalculoManipulacao.Dose:
                qtdStr = this.$t("__.ts.qtdTotalRepresMultQtd") as string;
                break;
            default:
                qtdStr = this.$t("__.ts.semCalcEspecifQtdIgualQtd") as string;
        }

        const fatorCorrecao = this.model.fatorCorrecao ?? 0;
        const densidade = this.model.densidade ?? 0;
        const fatorUI = this.model.fatorUI ?? 0;
        const fatorEquivalencia = this.model.fatorEquivalencia ?? 0;

        let obs = fatorCorrecao > 0 ? this.$t("__.ts.obsPossuiFtrCorrec") + fatorCorrecao.toString() : "";

        if (densidade > 0) {
            obs += `. Possui densidade igual a ${densidade.toString()}.`;
        }

        if (fatorUI > 0) {
            const texto = obs != "" ? `${obs}${this.$t("__.ts.eP")}` : (this.$t("__.ts.obsP") as string);
            obs = texto + this.$t("__.ts.ossuiFtrIgual") + fatorUI.toString();
        }

        if (fatorEquivalencia > 0) {
            obs += `. Possui fator de equivalência igual a ${fatorEquivalencia.toString()}.`;
        }

        return qtdStr + obs + (obs != "" ? "." : "");
    }

    private getTooltipUnidadeMedidaDose(unDose: number) {
        this.loadManipulacaoContext();

        if (unDose != null && unDose > 0) {
            const unMed = this.unidadeMedidaOptions.filter(p => p["value"] == this.manipulacao.unidadeMedidaId);
            if (unMed.length > 0) {
                return this.unidadeMedidaOptions.filter(p => p["value"] == this.manipulacao.unidadeMedidaId)[0]["text"];
            }
        }

        return "";
    }

    private getSignalQuantidade(tipo: TiposCalculoManipulacao, total: boolean, campoQtdDose = false) {
        this.loadManipulacaoContext();

        if (!total && this.itemType == ItemTableType.ATIVO) {
            switch (tipo) {
                case TiposCalculoManipulacao.Unitario:
                    if (
                        !campoQtdDose &&
                        this.model.unidadeMedidaId > 0 &&
                        this.unidadeMedidaOptions.some(p => p["value"] == this.model.unidadeMedidaManipulacaoId)
                    )
                        return this.getSiglaUnidadeMedida(this.model.unidadeMedidaManipulacaoId);
                    return "";
                case TiposCalculoManipulacao.Percentual:
                case TiposCalculoManipulacao.UIPercentual:
                case TiposCalculoManipulacao.UTRPercentual:
                    if (total && this.unidadeMedidaOptions.some(p => p["value"] == this.manipulacao.unidadeMedidaId)) {
                        return this.getSiglaUnidadeMedida(this.manipulacao.unidadeMedidaId ?? 0);
                    }
                    return "%";
                case TiposCalculoManipulacao.Nenhum:
                    if (
                        !campoQtdDose &&
                        this.unidadeMedidaOptions.some(p => p["value"] == this.model.unidadeMedidaManipulacaoId)
                    )
                        return this.getSiglaUnidadeMedida(this.model.unidadeMedidaManipulacaoId);
                    return "";
                case TiposCalculoManipulacao.Dose:
                    if (
                        this.model.unidadeMedidaId > 0 &&
                        total &&
                        this.unidadeMedidaOptions.some(p => p["value"] == this.model.unidadeMedidaManipulacaoId)
                    )
                        return this.getSiglaUnidadeMedida(this.model.unidadeMedidaManipulacaoId);
                    return "";
                case TiposCalculoManipulacao.Qsp:
                    if (
                        this.model.unidadeMedidaId > 0 &&
                        total &&
                        this.unidadeMedidaOptions.some(p => p["value"] == this.model.unidadeMedidaManipulacaoId)
                    )
                        return this.getSiglaUnidadeMedida(this.model.unidadeMedidaManipulacaoId);
                    return "";
                default:
                    return "";
            }
        } else {
            if (this.unidadeMedidaOptions.some(p => p["value"] == this.model.unidadeMedidaId)) {
                return this.getSiglaUnidadeMedida(this.model.unidadeMedidaId);
            }
        }
        return "";
    }

    private getSiglaUnidadeMedida(value: number) {
        return this.unidadeMedidaOptions.filter(p => p["value"] == value)[0]["text"];
    }

    private tabIndex(valor: number | null | undefined) {
        if (valor != null && valor > 0) return -1;
        return null;
    }

    private onCancelar() {
        this.clear();
    }

    private async openComboVerProduto() {
        while (!this.$refs.produtoVerComponent) await Delay(5);
        this.produtoVerComponent = this.$refs.produtoVerComponent as ProdutoVerComponent;

        this.produtoVerComponent.load(this.model.produtoId, this.model.quantidadePesagem);
    }

    private loadProduto() {
        if (!this.produtoId && this.model.produtoId) {
            this.produtoId = this.model.produtoId;
        }
        this.loadProdutoPaiPuro();
    }

    private setUnidadeMedidaCalculoPercentual(item: ManipulacaoOrdemItemModel) {
        this.loadManipulacaoContext();

        item.unidadeMedidaManipulacaoId = this.manipulacao.unidadeMedidaId ?? 0;

        if (item.unidadeMedidaManipulacaoId > 0) {
            const unidadesMedida = this.unidadeMedidaOptions.filter(p => p["value"] == item.unidadeMedidaManipulacaoId);
            if (unidadesMedida.length > 0) {
                item.unidadeMedidaManipulacaoDecricao = unidadesMedida[0]["text"];
            }
        }
        return item;
    }

    private async dispatch(action: ManipulacaoContextNewActions, data: unknown) {
        await this.$store.dispatch(action, { uuid: this.uuid, data });

        this.loadManipulacaoContext();
    }

    public loadManipulacaoContext() {
        this.manipulacaoContext = this.GET_MANIPULACAO_CONTEXT_NEW(this.uuid);
        this.manipulacao = this.manipulacaoContext.manipulacao;
    }

    public unsubscribeAll() {
        this.unsubscribe?.();
    }

    private async loadProdutoCoresCapsulas() {
        if (this.model.capsulaId) {
            const franquiaId = this.manipulacaoContext.isFranquiaFilial
                ? this.manipulacaoContext.estoqueFranquiaId
                : this.usuarioLogado.franquiaId;

            const data = (await capsulaCoresService.produtosCoresByFranquiaCached(franquiaId ?? 0)) ?? [];

            this.coresCapsulasOptions = data
                .filter(p => p.capsulaId == this.model.capsulaId)
                .filter(p => (!this.manipulacao.id ? p.ativo : true))
                .filter(p => p.tipoCapsula == this.manipulacaoContext.manipulacao?.formaFarmaceutica?.tipoCapsula)
                .map(p => ({ text: p.descricao, value: p.id }));
        }
    }

    private loadProdutoPaiPuro() {
        this.produtoPaiPuro = null;
        this.unidadeMedidaIdProduto = 0;

        const produto = this.model.produto;
        if (produto?.id) {
            this.unidadeMedidaIdProduto = produto.unidadeMedidaManipulacaoId ?? 0;

            const produtosPuros = produto.produtoPuros ?? [];
            if (produtosPuros.length > 0) {
                for (let i = 0; i < produtosPuros.length; i++) {
                    const prodPuro = this.produtosOptions.filter(p => p["value"] == produtosPuros[i].id);

                    if (prodPuro.length > 0) {
                        this.produtoPaiPuro = new ProdutoModel();
                        this.produtoPaiPuro.updateFrom(produtosPuros[i]);
                        break;
                    }
                }
            }
        }
    }

    private async loadValoresProdutoByLote(
        usaMarkupEquinos?: boolean,
        manipulacao: ManipulacaoOrdemModel | null = null,
    ) {
        let item: ManipulacaoOrdemItemModel | undefined;
        try {
            if (manipulacao != null && manipulacao.itens.some(p => p.produtoId == this.model.produtoId)) {
                item = manipulacao.itens.find(p => p.produtoId == this.model.produtoId);
            } else {
                item = await this.manipulacaoOrdemItemService
                    .loadDadosProdutoLote(
                        this.model,
                        this.manipulacao,
                        usaMarkupEquinos,
                        this.manipulacaoContext.isTransferencia,
                        this.manipulacaoContext.atualizaDadosLote,
                    )
                    .resolveWithJSON<ManipulacaoOrdemItemModel>();
            }

            if (!item) {
                return;
            }

            if (this.manipulacao.formaFarmaceutica.desconsiderarDensidade) {
                item.densidade = 1;
            }

            this.model.densidade = item.densidade;
            this.model.fatorCorrecao = item.fatorCorrecao;
            this.model.fatorUI = item.fatorUI;
            this.model.fatorUFC = item.fatorUFC;
            this.model.fatorUTR = item.fatorUTR;
            this.model.produtoLoteCalculosId = item.produtoLoteCalculosId;
            this.model.valor = item.valor;
            this.model.produto = item.produto ?? this.model.produto;
        } catch {}
    }

    public remontarFormulaPadraoDesmembrada() {
        if (
            this.isFormulaPadrao &&
            this.model.tipoCalculo == TiposCalculoManipulacao.Qsp &&
            this.manipulacaoContext.isConsolidando
        ) {
            this.loadManipulacaoContext();

            this.loadModelByFormulaPadrao();
        }
    }

    private async mounted() {
        this.isFracionamento = await this.GET_IS_FRACIONAMENTO();
        this.isEstereis = await this.GET_IS_ESTEREIS();

        const response = await Promise.all([
            capsulaService.comboCached(this.usuarioLogado.franquiaId ?? 0),
            unidadeMedidaService.comboCached(this.usuarioLogado.franquiaId ?? 0),
            this.loadFormulaPadrao(),
            this.loadProdutoOptions(),
        ]);

        this.capsulasOptions = response[0];
        this.unidadeMedidaOptions = response[1];

        if (this.manipulacaoContext.isFranquiaFilial) {
            this.formulaPadraoOptions = await formulaPadraoDesmembradoService.comboCachedByEstoque(
                this.manipulacao.estoqueId ?? 0,
            );
        }

        this.unsubscribe = this.$store.subscribe(mutation => {
            switch (mutation.type) {
                case ManipulacaoContextNewMutations.REMOVE_ATIVOS_ASSOCIADOS_NEW:
                case ManipulacaoContextNewMutations.REMOVE_DESMEMBRADOS_NEW:
                case ManipulacaoContextNewMutations.UPDATE_MANIPULACAO_NEW:
                    this.loadManipulacaoContext();
                    break;
                case ManipulacaoContextNewMutations.CONSOLIDAR_NEW:
                    this.$forceUpdate();
                    break;
            }
        });

        this.loadManipulacaoContext();

        this.tiposCalculoOptions = [
            { text: "Nenhum", value: 0 },
            { text: "Unitário", value: 1 },
            { text: "Percentual", value: 2 },
            { text: "Qsp", value: 3 },
            { text: "Dose", value: 4 },
            { text: "UTR Percentual", value: 5 },
            { text: "DH", value: 6 },
            { text: "CH", value: 7 },
            { text: "UI Percentual", value: 8 },
        ];

        if (this.manipulacao.homeopatia) {
            this.tiposCalculoOptions = this.tiposCalculoOptions.filter(
                p => (p["value"] > 5 && p["value"] != 8) || p["value"] == 2 || p["value"] == 3,
            );
        } else {
            this.tiposCalculoOptions = this.tiposCalculoOptions.filter(p => p["value"] <= 5 || p["value"] == 8);
        }

        this.loading = true;
        if (this.itemModel != null) {
            this.model.updateFrom(this.itemModel);

            this.isFormulaPadrao = false;
            if (this.model.tipoItem == TiposItemManipulacao.FormulaPadrao) {
                this.isFormulaPadrao = true;
            }

            if (this.model.produtoId > 0) {
                if (this.isFormulaPadrao) {
                    this.itensDesemembradosFormulaBase = [];

                    let itensByFormula = this.manipulacaoContext.desmembrados.filter(
                        p => p.formulaPadraoId == this.model.formulaPadraoId,
                    );

                    itensByFormula = [
                        ...itensByFormula,
                        ...this.manipulacaoContext.desmembrados.filter(
                            p =>
                                itensByFormula.map(i => i.produtoId).includes(p.produtoPai ?? 0) &&
                                !itensByFormula.map(i => i.produtoId).includes(p.produtoId),
                        ),
                    ];

                    itensByFormula.forEach(p => {
                        p.produtoDescricao = `${this.getNivelDesmembrado(p.produtoPai)}${p.produtoDescricao}`;
                        p.manipulacaoOrdemItemProdutoPaiId = this.model.produtoId;
                        this.itensDesemembradosFormulaBase.push(p);
                    });
                }

                this.loadProduto();
            } else {
                this.model.unidadeMedidaManipulacaoId = this.manipulacao.unidadeMedidaId ?? 0;
                this.model.unidadeMedidaId = this.manipulacao.unidadeMedidaId ?? 0;
            }
        } else {
            this.model.tipoItem = (this.itemType + 1) as TiposItemManipulacao;
        }

        this.loading = false;
    }
}
